import React, { useEffect, useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const Manglacharan = () => {
  const manglacharanArray = [
    { id: 1, name: '01_સહજાનંદ_ગુરુ.png', color: '#088b41', src: '/images/01.png', char: 'z' },
    { id: 2, name: '02_રાજાધિરાજ.png', color: '#088b41', src: '/images/02.png', char: 'z' },
    { id: 3, name: '03_સ્વામિનારાયણ_ભગવાન.png', color: '#088b41', src: '/images/03.png', char: 'z' },
    { id: 4, name: '04_હરિકૃષ્ણ_મહારાજ.png', color: '#088b41', src: '/images/04.png', char: 'z' },
    { id: 5, name: '05_ઘનશ્યામ_મહારાજ.png', color: '#088b41', src: '/images/05.png', char: 'z' },
    { id: 6, name: '06_નીલકંઠ_વર્ણી.png', color: '#088b41', src: '/images/06.png', char: 'z' },
    { id: 7, name: '07_સહજાનંદ_સ્વામી.png', color: '#088b41', src: '/images/07.png', char: 'z' },
    { id: 8, name: '08_ગોપાળાનંદ_સ્વામી.png', color: '#088b41', src: '/images/08.png', char: 'z' },
    { id: 9, name: '09_મુક્તાનંદ_સ્વામી.png', color: '#088b41', src: '/images/09.png', char: 'z' },
    { id: 10, name: '10_નિત્યાનંદ_સ્વામી.png', color: '#088b41', src: '/images/10.png', char: 'n' },
    { id: 11, name: '11_બ્રહ્માનંદ_સ્વામી.png', color: '#088b41', src: '/images/11.png', char: 'b' },
    { id: 12, name: '12_ગુણાતીતાનંદ_સ્વામી.png', color: '#088b41', src: '/images/12.png', char: 'g' },
    { id: 13, name: '13_નિષ્કુળાનંદ_સ્વામી.png', color: '#088b41', src: '/images/13.png', char: 'n' },
    { id: 14, name: '14_પ્રેમાનંદ_સ્વામી.png', color: '#088b41', src: '/images/14.png', char: 'p' },
    { id: 15, name: '15_શુકાનંદ_સ્વામી.png', color: '#088b41', src: '/images/15.png', char: 's' },
    { id: 16, name: '16_શતાનંદ_સ્વામી.png', color: '#088b41', src: '/images/16.png', char: 's' },
    { id: 17, name: '17_સ્વરૂપાનંદ_સ્વામી.png', color: '#088b41', src: '/images/17.png', char: 's' },
    { id: 18, name: '18_સચ્ચિદાનંદ_સ્વામી.png', color: '#088b41', src: '/images/18.png', char: 's' },
    { id: 19, name: '19_સિધ્ધાનંદ_સ્વામી.png', color: '#088b41', src: '/images/19.png', char: 's' },
    { id: 20, name: '20_સદાનંદ_સ્વામી.png', color: '#088b41', src: '/images/20.png', char: 's' },
    { id: 21, name: '21_વ્યાપકાનંદ_સ્વામી.png', color: '#088b41', src: '/images/21.png', char: 'v' },
    { id: 22, name: '22_આધારાનંદ_સ્વામી.png', color: '#088b41', src: '/images/22.png', char: 'a' },
    { id: 23, name: '23_આનંદાનંદ_સ્વામી.png', color: '#088b41', src: '/images/23.png', char: 'a' },
    { id: 24, name: '24_ભાઈરામદાસ_સ્વામી.png', color: '#088b41', src: '/images/24.png', char: 'b' },
    { id: 25, name: '25_ભાયાત્માનંદ_સ્વામી.png', color: '#088b41', src: '/images/25.png', char: 'b' },
    { id: 26, name: '26_યોગાનંદ_સ્વામી.png', color: '#088b41', src: '/images/26.png', char: 'y' },
    { id: 27, name: '27_ચૈતન્યાનંદ_સ્વામી.png', color: '#088b41', src: '/images/27.png', char: 'c' },
    { id: 28, name: '28_કૃપાનંદ_સ્વામી.png', color: '#088b41', src: '/images/28.png', char: 'k' },
    { id: 29, name: '29_મહાનુભાવાનંદ_સ્વામી.png', color: '#088b41', src: '/images/29.png', char: 'm' },
    { id: 30, name: '30_રાધારમણ_સ્વામી.png', color: '#088b41', src: '/images/30.png', char: 'r' },
    { id: 31, name: '31_ભક્તરાજ_દાદાખાચર.png', color: '#088b41', src: '/images/31.png', char: 'b' },
    { id: 32, name: '32_ગુરુજી.png', color: '#088b41', src: '/images/32.png', char: 'g' }
  ];

  const navigate = useNavigate();

  const [selectedId, setSelectedId] = useState(0);

  const [displayArr, setDisplayArr] = useState(manglacharanArray);

  const handleVMixInput = async (inputId) => {
    let vmixSettings = localStorage.getItem("vmixSettings");

    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      if (vmixSettings.webControllerUrl === "") return false;

      let url = `${vmixSettings.webControllerUrl}/api/?Function=OverlayInput2&input=${inputId}`;
      try {
        await fetch(url, { mode: "no-cors" });
        return true;
      } catch (e) {
        toast.error(url);
        console.log('e: ', e);
        return false;
      }
    }
  };

  const handleSelectedPhotoId = async (id, name) => {
    const res = await handleVMixInput(name);
    res && selectedId !== id ? setSelectedId(id) : setSelectedId(0);
  };

  const handleSearchKey = (key) => {
    const char = key.toLowerCase();
    if (key === ' ') {
      const selectedName = manglacharanArray.find(manglacharanArray => manglacharanArray.id === selectedId);
      if (selectedName) {
        handleSelectedPhotoId(selectedId, selectedName?.name);
      }
      setDisplayArr(manglacharanArray);
    } else {
      const filteredArray = manglacharanArray.filter(item => item.char === char || item.char === 'z');
      setDisplayArr(filteredArray);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Escape") {
      const selectedName = manglacharanArray.find(manglacharanArray => manglacharanArray.id === selectedId);
      if (selectedName) {
        handleSelectedPhotoId(selectedId, selectedName?.name);
      }
      navigate('/');
    }
    else {
      handleSearchKey(event.key);
    }
  };

  useEffect(() => {
    // Add event listener when the component mounts
    window.addEventListener('keydown', handleKeyPress);

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return <>
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
    <h4 className="text-[#3e3e3e] text-4xl mb-1 font-bold tracking-[2px] text-center relative">
      <div>
        <h4>vMix Manglacharan</h4>
      </div>
    </h4>
    <button className="absolute top-1 right-2 px-1 pb-1 text-xl bg-red-600 text-white rounded-full" onClick={() => { navigate('/'); }}><ArrowBackIcon /></button>
    <div className="my-3 mx-5 ">
      <div className="grid 2xl:grid-cols-7 xl:grid-cols-7 lg:grid-cols-6 md:grid-cols-4 gap-4 h-full content-center items-center">
        {
          displayArr.map(item => {
            return <>
              <div className={`2xl:w-56 2xl:h-48 xl:w-40 xl:h-32 lg:w-36 lg:h-40 md:w-36 md:h-36 text-center flex flex-col justify-between items-center border-2 overflow-y-hidden ${selectedId === item.id ? `border-[#FFBD8E]` : `border-[#F1F1F1]`} rounded-3xl`}
                id={item.id}
                onClick={() => { handleSelectedPhotoId(item.id, item.name); }}>
                <div><img className="2xl:w-[133px] 2xl:h-[132px] 2xl:mt-2 xl:w-[77px] xl:h-[80px] xl:mt-1 lg:w-[95px] lg:h-[105px] lg:mt-3 md:w-[90px] md:h-[99px] md:mt-3" src={`${item.src}`} alt="not-available"></img></div>
                <div className={`2xl:text-base font-bold 2xl:h-10 xl:h-8 lg:h-6 md:h-6  w-full content-center ${selectedId === item.id ? `bg-[#FFBD8E]` : `bg-[#F1F1F1]`} text-[10px]`}>{item.name.substring(0, item.name.length - 4)}</div>
              </div>
            </>;
          })
        }
      </div>
    </div>
  </>;
};

export default Manglacharan;
